import React, { useMemo } from "react";
import { Button } from "antd";
import StyledModal from "../CustomModal";
import { FooterButtons } from "./styles";

type ConfirmationModalProps = {
  title: string;
  message: string;
  isModalOpen: boolean;
  handleSave: () => void;
  onCancel: () => void;
  CancelButtonText?: string;
  confirmButtonText?: string;
  loading?: boolean;
  hasAddPermission?: boolean;
  hasEditPermission?: boolean;
  hasViewPermission?: boolean;
  closeIcon?: React.ReactNode;
  footerButton?: React.ReactNode;
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ title, message, isModalOpen, handleSave, onCancel, confirmButtonText, CancelButtonText, loading, hasAddPermission, hasEditPermission, hasViewPermission, closeIcon, footerButton }) => {

  const canSaveChanges = useMemo(() => hasAddPermission || hasEditPermission, [hasAddPermission, hasEditPermission]);

  return (
    <StyledModal
      title={title}
      open={isModalOpen}
      closeIcon={closeIcon}
      footer={footerButton ? footerButton : (
        <FooterButtons>
          <Button onClick={onCancel} disabled={loading}>{CancelButtonText || "Cancel"}</Button>
          <Button type="primary" onClick={handleSave} loading={loading}>
            {confirmButtonText || "Confirm"}
          </Button>
        </FooterButtons>
      )}
      centered
      onCancel={onCancel}
    >
      <p>{message}</p>
    </StyledModal>
  );
};

export default ConfirmationModal;
